export class TaxSetupRequest {
  webApiName: string;
  webApiVersion: number;
  requestId: string;
  requestInfo: TaxSetupRequestInfo;
}

export class TaxSetupRequestInfo {
  taxSetupId: number;
  organisationId: number;
  rateCode: string;
  isSingleTaxRate: boolean;
  stateId: number;
  createdBy: number;
  createdOn: number;
  updatedBy: number;
  updatedOn: number;
  isTaxRateOn:boolean;
  wizardStep:number;
}
